<template>
  <b-dropdown-item 
    v-if="!loading"
    variant="danger" 
    v-gk-confirm="{
      title: $gettext('Delete permanently?'),
      message: deleteWarningText,
      options: {
        warning: warningText,
        item: itemText + ' - ' + item.number,
        variant: 'danger',
        confirmText: $gettext('Delete permanently'),
        safeguard: (itemType === 'invoice' && item.status !== 'd'),
        safeguardText: safeguardText
      },
      callback: deleteItem,
      callbackParams: item.id
    }"
  >
    <font-awesome-icon icon="fa-regular fa-trash-can" />
    <span>{{ deleteText }}</span>
  </b-dropdown-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DropdownItemDelete',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    itemType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      itemText: '',
      deleteText: '',
      deleteFnName: '',
      deleteWarningText: this.$gettext('You\'re about to delete this item permanently. This can\'t be undone.'),
      warningText: null,
      safeguardText: null
    }
  },
  created () {
    this.setupData()
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany'
    })
  },
  methods: {
    ...mapActions({ 
      deleteInvoice: "invoices/deleteInvoice",
      deleteQuotation: "invoices/deleteQuotation",
      deleteCost: "costs/deleteCost",
    }),
    setupData () {
      switch (this.itemType) {
        case 'invoice':
          this.deleteFnName = '_deleteInvoice'
          if (this.item.status !== 'd' && !this.item.correction) {
            if (this.currentCompany.country === 'NL') {
              this.warningText = this.$gettext('Under Dutch law, it is prohibited to delete any invoices that have been sent and received by customers for services that have been delivered. In case you made a mistake in an invoice that has already been sent, you should not delete the incorrect invoice but send a new credit invoice, correcting your mistake.')
            } else if (this.currentCompany.country === 'ES') {
              this.warningText = this.$gettext('Under Spanish law, it is prohibited to delete any invoices that have been sent and received by customers for services that have been delivered. In case you made a mistake in an invoice that has already been sent, you should not delete the incorrect invoice but send a new credit invoice, correcting your mistake.')
            } else {
              this.warningText = this.$gettext('Under your country\'s laws, it is prohibited to delete any invoices that have been sent and received by customers for services that have been delivered. In case you made a mistake in an invoice that has already been sent, you should not delete the incorrect invoice but send a new credit invoice, correcting your mistake.')
            }
            
            this.safeguardText = this.$gettext('I agree and understand the implications')
          }
          if (this.item && this.item.correction !== null) {
            this.deleteText = this.$gettext('Delete correction')
            this.itemText = this.$gettext('CORRECTION')
          } else {
            this.deleteText = this.$gettext('Delete invoice')
            this.itemText = this.$gettext('INVOICE')
          }
          break;
        case 'quotation':
          this.deleteFnName = '_deleteQuotation'
          this.deleteText = this.$gettext('Delete quotation')
          this.itemText = this.$gettext('QUOTATION')
          break;
        case 'cost':
          this.deleteFnName = '_deleteCost'
          this.deleteText = this.$gettext('Delete cost')
          this.itemText = this.$gettext('COST')
          break;
      }
      this.loading = false
    },
    deleteItem (item_id) {
      this[this.deleteFnName](item_id)
    },
    _deleteInvoice (item_id) {
      this.deleteInvoice(item_id).then(() => {
        this.onDelete(item_id)
      }).catch((error) => {
        if (error.status === 409) {
          this.$store.commit('setAlert', {
            title: this.$gettext('Invoice not deleted'),
            text: error.data.detail,
            variant: 'danger',
            duration: 4
          })
        } else {
          this.$store.commit('setAlert', {
            title: this.$gettext('Error'),
            text: this.$gettext('The invoice could not be deleted.'),
            variant: 'danger',
            duration: 4
          })
        }
      })
    },
    _deleteQuotation (item_id) {
      this.deleteQuotation(item_id).then(() => {
        this.onDelete(item_id)
      })
    },
    _deleteCost (item_id) {
      this.deleteCost(item_id).then(() => {
        this.onDelete(item_id)
      })
    },
    onDelete (item_id) {
      this.$emit('item-deleted', item_id)
      this.$store.commit('setAlert', {
        title: this.$gettext('Item deleted'),
        text: this.$gettext('Item was deleted successfully'),
        variant: 'primary',
        duration: 4
      })
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
